export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/investor_pitch_fundraising.c15b435.svg";